export const LANGUAGE_MULTI_SELECT_NAMESPACE = 'language-multi-select';
